var map = {
	"./de/text-xbox.png": "rFRs",
	"./en/text-xbox.png": "vhR0",
	"./es/text-xbox.png": "/Qq6",
	"./fr/text-xbox.png": "WLeD",
	"./ja/text-xbox.png": "Tjg3",
	"./ko/text-xbox.png": "4mUW",
	"./pt/text-xbox.png": "5Qei",
	"./ru/text-xbox.png": "aPsN",
	"./th/text-xbox.png": "4LOB",
	"./zh-Hant/text-xbox.png": "/l6T"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "XEeN";